import { Reveal, StaggerGroup, StaggerItem } from "../site/Motion";
import { SectionLabel, Icon } from "../site/Bits";
import { BENEFITS } from "../../lib/site";

export const Benefits = () => (
  <section className="relative bg-white py-24" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>Key benefits</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          Real outcomes, not just reminders.
        </h2>
      </Reveal>

      <StaggerGroup className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b) => (
          <StaggerItem key={b.title}>
            <div
              data-testid={`benefit-${b.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="h-full rounded-3xl border border-slate-200 bg-background p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-greenaccent/10 text-greenaccent">
                <Icon name={b.icon} className="h-6 w-6" />
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold text-ink">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{b.desc}</p>
            </div>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default Benefits;
